<template>
  <div class="mobile-content2">
    <div class="title-container">
      <div class="title-dec-left">
        <img src="@/assets/image/title-dec.png" alt="title decoration left" />
      </div>
      <div class="title-text">特色功能，嗨爆现场</div>
      <div class="title-dec-right">
        <img src="@/assets/image/title-dec.png" alt="title decoration right" />
      </div>
    </div>

    <div class="card-show-container">
      <div
        v-for="(card, index) in cardList"
        :key="index"
        class="card"
      >
        <div class="card-image">
          <img
            v-if="card.cardImage"
            :src="card.cardImage"
            :alt="card.cardAlt"
          />
        </div>
        <div class="card-content">
          <div class="card-title-wrapper">
            <div class="card-title">
              {{ card.cardTitle }}
            </div>
          </div>
          <div class="tags">
            <div
              v-for="(tag, tagIndex) in card.cardContent"
              :key="tagIndex"
              class="tag"
            >
              {{ tag }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pagination-dots">
      <span
        v-for="dot in 3"
        :key="dot"
        class="dot"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileContent2',
  data() {
    return {
      cardList: [
        {
          cardTitle: '扫码签到，祝福上墙',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/bemy_1767854163016c52f34.webp',
          cardAlt: '微信扫码签到送祝福',
          cardContent: ['签到', '心墙', '表白'],
        },
        {
          cardTitle: '礼物霸屏，金榜题名',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/lwbp_17678541983602baef5.webp',
          cardAlt: '礼物霸屏土豪专属',
          cardContent: ['特效', '照片', '赞赏'],
        },
        {
          cardTitle: '幸运抽奖，好运连连',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/xycj_1767854237120d14c0f.webp',
          cardAlt: '酒吧顾客参与现场抽奖',
          cardContent: ['头像抽奖', '名单抽奖', '照片抽奖'],
        },
        {
          cardTitle: '互动游戏，趣味加倍',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/hdyx_1767854271701e54374.webp',
          cardAlt: '经典大屏互动摇一摇赛车游戏',
          cardContent: ['摇一摇', '划一划', '点一点'],
        },
        {
          cardTitle: '荭包雨落，全场欢呼',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/hbyl_1767854303370e16eb8.webp',
          cardAlt: '经典大屏互动荭包雨游戏',
          cardContent: ['福利', '荭包', '好运'],
        },
        {
          cardTitle: '扫码点歌，唱出所爱',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/smdg_176785433360319aa0d.webp',
          cardAlt: '酒吧顾客扫码点歌方便快捷',
          cardContent: ['点歌', '打赏', '金曲'],
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.mobile-content2 {
  width: 100%;
  margin-top: 56px;

  .title-container {
    height: 38px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    gap: 12px;

    .title-dec-left {
      img {
        width: 61px;
        height: 21px;
        display: block;
        object-fit: contain;
      }
    }

    .title-text {
      font-weight: 700;
      font-size: 26px;
      color: #FFFFFF;
      align-self: flex-end;
      line-height: 1;
    }

    .title-dec-right {
      img {
        width: 61px;
        height: 21px;
        display: block;
        object-fit: contain;
        transform: scaleX(-1);
      }
    }
  }

  .card-show-container {
    margin-top: 32px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    gap: 30px;

    .card {
      width: 315px;
      height: 256px;
      border-radius: 12px;
      border: 2px solid #C95EFB;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .card-image {
        width: 100%;
        height: 174px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }

      .card-content {
        width: 100%;
        height: 82px;
        padding: 0;
        position: relative;
        background: linear-gradient(270deg, #4A20BA 0%, #9535BF 100%);

        .card-title-wrapper {
          width: 100%;
          height: 32px;

          .card-title {
            width: 185px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            font-size: 18px;
            color: #FFFFFF;
            border-radius: 8px;
            background-image: url('~@/assets/image/card-title.png');
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
          }
        }

        .tags {
          width: 100%;
          margin-top: 10px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          gap: 11px;

          .tag {
            min-width: 70px;
            padding: 0 12px;
            height: 27px;
            border-radius: 14px;
            border: 1px solid #FFFFFF;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 500;
            font-size: 15px;
            color: #FFFFFF;
            box-sizing: border-box;
          }
        }
      }
    }
  }

  .pagination-dots {
    margin: 38px auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;

    .dot {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: #FFFFFF;
    }
  }
}
</style>
